import type { ContentTableAction } from "./content-table.types"
export const CONTENT_TABLE_SELECT_REGION: string = "CONTENT_TABLE_SELECT_REGION"
export const CONTENT_TABLE_SELECT_SUBREGION: string = "CONTENT_TABLE_SELECT_SUBREGION"
export const CONTENT_TABLE_SELECT_MAP: string = "CONTENT_TABLE_SELECT_MAP"
export const CONTENT_TABLE_CLEAR_SELECTION: string = "CONTENT_TABLE_CLEAR_SELECTION"

export function selectRegion(regionId: string): ContentTableAction {
  return {
    type: CONTENT_TABLE_SELECT_REGION,
    payload: regionId
  }
}

export function selectSubRegion(subRegionId: string): ContentTableAction {
  return {
    type: CONTENT_TABLE_SELECT_SUBREGION,
    payload: subRegionId
  }
}

export function selectMap(mapId: string): ContentTableAction {
  return {
    type: CONTENT_TABLE_SELECT_MAP,
    payload: mapId
  }
}

export function clearSelection(): ContentTableAction {
  return {
    type: CONTENT_TABLE_CLEAR_SELECTION
  }
}
